import { all } from 'redux-saga/effects';

import signUpSagas from './SignUp/sagas';

export default function* rootSaga() {
  return yield all([signUpSagas]);
}
